export default __webpack_public_path__ + "static/media/img-b-end-bg@2x.a5f2db9d.jpg";